module.exports = __webpack_public_path__ + "static/media/10102020-haywire-weekend-tv.0283e3ce.mp4";